<template>
  <span 
    v-b-tooltip.top.dh0="{customClass: 'otherDealerTooltip'}"
    :title="title"
    :key="iconkey"
  >
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.79455 5.52597L0.5 4.56966L1.00182 2.96517L4.29636 4.15525L4.19818 0.5H5.86727L5.75818 4.20838L8.99818 3.03955L9.5 4.65466L6.15091 5.62161L8.31091 8.50118L6.95818 9.5L4.92909 6.43979L2.96545 9.42562L1.60182 8.45868L3.79455 5.52597Z" fill="#4B5563"/>
    </svg>
  </span>
</template>

<script>
    export default {
        name: "IconOtherDealer",
        props: ['iconkey','title']
    }
</script>

<style lang="css">
  .otherDealerTooltip.tooltip{
    opacity: 1 !important;
    top:-2px !important;
  }
  .otherDealerTooltip .tooltip-inner {
    background-color: #4B5563 !important;
  }
  .otherDealerTooltip.tooltip.bs-tooltip-top .arrow::before, .otherDealerTooltip.tooltip.bs-tooltip-auto[x-placement^="top"] .arrow::before {
    border-top-color: #4B5563 !important;
  }
</style>